import { mergeClassName as e } from "../../utils/data.js";
import t from "./Typography.module.js";
import { jsxDEV as n } from "react/jsx-dev-runtime";
//#region lib/components/Typography/Typography.tsx
var r = "/opt/render/project/src/shared-ui/lib/components/Typography/Typography.tsx";
function i({ variant: i = "body-small", weight: a, children: o, className: s, paragraph: c, alignItems: l, style: u, ...d }) {
	let f = i.startsWith("display-"), p = i.startsWith("heading-"), m = a ?? (f || p ? "medium" : "regular"), h = e(t[i], t[m], l ? t.aligned : void 0, s), g = {
		alignItems: l,
		...u
	};
	switch (i) {
		case "display-extra-large":
		case "display-large":
		case "display-medium":
		case "display-small":
		case "heading-large":
		case "heading-medium":
		case "heading-small": return /* @__PURE__ */ n("div", {
			className: h,
			style: g,
			...d,
			children: o
		}, void 0, !1, {
			fileName: r,
			lineNumber: 99,
			columnNumber: 17
		}, this);
		default: return c ? /* @__PURE__ */ n("p", {
			className: h,
			style: g,
			...d,
			children: o
		}, void 0, !1, {
			fileName: r,
			lineNumber: 106,
			columnNumber: 17
		}, this) : /* @__PURE__ */ n("span", {
			className: h,
			style: g,
			...d,
			children: o
		}, void 0, !1, {
			fileName: r,
			lineNumber: 110,
			columnNumber: 17
		}, this);
	}
}
//#endregion
export { i as Typography };
